



















































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "SerialWidget",
  components: { MagicValidator }
})
export default class SerialWidget extends EventWidgetComponent {}
